import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { reloadPage } from '../../../utils/platform/reload-page';
import ErrorFallback from './ErrorFallback';

interface IErrorBoundaryProps {
  children: React.ReactNode;
  onReset?: () => void;
}

export default function ErrorBoundary({
  children,
  onReset,
}: IErrorBoundaryProps) {
  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      reloadPage();
    }
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={handleReset}
      onError={(error, errorInfo) => {
        if (process.env.NODE_ENV === 'development') {
          console.error('ErrorBoundary caught an error:', error, errorInfo);
        }
      }}>
      {children}
    </ReactErrorBoundary>
  );
}
